import Content from '@/components/Content';
import PartnerDocumentsPanel from '@/components/PartnerDocumentsPanel';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { User } from 'src/api/User';
import { useI18n } from 'src/i18n/I18nContext';

interface PartnerLandingProps {
    user: User;
}

const PartnerLanding = ({ user }: PartnerLandingProps) => {
    const { t } = useI18n();

    return (
        <Content>
            <Flex maxW='6xl' mx='auto' w='full' direction='column' gap='6' px={{ base: 3, lg: 0 }}>
                <Box>
                    <Text fontSize={{ base: 'lg', lg: '2xl' }} fontWeight='medium'>
                        {t('landing.partner.welcome', { name: user.firstName })}
                    </Text>
                    <Heading as='h1' size={{ base: '2xl', lg: '3xl' }} mt='2'>
                        {t('landing.partner.title')}
                    </Heading>
                </Box>

                {!user.partnerId && (
                    <Box borderWidth='1px' borderColor='orange.300' rounded='lg' p='4' bg='orange.50'>
                        <Text fontWeight='semibold'>{t('landing.partner.missingPartnerTitle')}</Text>
                        <Text color='fg.muted'>{t('landing.partner.missingPartnerText')}</Text>
                    </Box>
                )}

                <PartnerDocumentsPanel canManage showSummary isAvailable={!!user.partnerId} />
            </Flex>
        </Content>
    );
};

export default PartnerLanding;
